import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader, useDrawer } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';

const dataProviderName = 'documents/document';
const wizardName = 'Car picture association';
const wizardObject = 'Car Picture';
const wizardAction = 'carPictureAssociation';

const CarPictureAssociation = (params) => {
    const { t } = useTranslation();
    const { close } = useDrawer();
    const { userCapabilities, existingModules } = useContext(AppContext);

    // DATA PROVIDER
    const {
        item,
        save,
        errorMessage,
        errors,
        saving,
        success
    } = useDataProvider(dataProviderName, params.multipart);

    const modelName = existingModules.modelName

    const detailConfig = {
        "tabs": [
            {
                "name": "document",
                "fieldsets": [
                    {
                        "name": "document",
                        "fields": {
                            "file": {
                                "type": "dropzone",
                                "className": "col-12",
                                "icon": "faFile"
                            },
                            "car": {
                                "type": "relationshipSingle",
                                "relation": {
                                    "drawerRoute": "cars"
                                },
                                "view": "car"
                            },
                        }
                    }
                ]
            }
        ],
        "validation": []
    }

    // DOCUMENT ****NON USA**** QUESTO PROCESSO DI CREAZIONE TRAMITE JOB
    // 
    // const handleSave = (data) => {
    //     doAction({action: wizardAction, model: dataProviderName, data: data}).then((data) => params.handleClose(params.uid, data.item.data)).catch(() => console.error('catch handleSave'));
    // }

    const handleSave = async (data) => {
        save && save({ ...data, filters: params.filters }).then(() => {close()})
    }
    
    return <>
        <DetailComponent
            values={{
                "id": item?.data?._id,
                "car": params?.car,
                "type": "carPicture",
                "visibleToDriver": "true",
                "name": t("Picture ")+(params?.car?.plate ? ' '+params?.car?.plate : '')
            }}
            modelName={modelName}
            detailConfig={detailConfig}
            save={handleSave}
            saving={saving}
            errors={errors}
            errorMessage={errorMessage}
            title={t(wizardName)}
            canSave={userCapabilities && userCapabilities[dataProviderName + '.' + wizardAction.toLowerCase()]}
            header={
                <InfoHeader
                    view="wizard"
                    title={t(wizardName)}
                    subtitle={t('Add a {{wizardObject}} to {{plate}}', { wizardObject: wizardObject, plate: params?.car?.plate })}
                />
            }
            {...params}
        />
    </>
}

export default CarPictureAssociation;


